import { render, staticRenderFns } from "./providerForm.vue?vue&type=template&id=58178d2c&scoped=true&"
import script from "./providerForm.vue?vue&type=script&lang=babel&"
export * from "./providerForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58178d2c",
  null
  
)

export default component.exports